export const isLoggedIn = ({ auth }) => !!auth.user.authToken
